import React, { createContext, useState, useEffect, ReactNode } from "react";
import {
  defaultflags,
  defaultlenguages,
  defaultxt,
  DefaultText,
} from "./defaultdata/defauldata";
import { FrontConfigurations } from "../../configurations/Axios/urls";
import useAxios from "../AxiosContext/AxiosContext";
import { User, Devices } from "../../configurations/Axios/urls";
import { useAuth } from "../AuthContext/AuthContext";
import { useLocation } from "react-router-dom";
import { loadOpenPay } from "../../utils/openpay";
// import { initMercadoPago } from '@mercadopago/sdk-react';

// initMercadoPago('TEST-9933f85f-e785-4df5-891d-1df668d49e23', { locale: 'es-MX' });

import { isProduction } from "../../configurations/Axios/Clients";

const LANGUAGE_STORAGE_KEY = "visitax_selected_language_flag";
interface ConfigurationsContextType {
  txt: DefaultText[];
  lenguageList: string[];
  flags: string[];
  currentlenguage: number;
  umaValue: number | null;
  price: {
    mxn: number;
    usd: number;
  };
  servicecharge: number | null;
  visitorsLimit: number | null;
  taxVisitax: number | null;
  CalcIndividualPrice: (NumberofVisitors: number) => number;
  setLenguage: React.Dispatch<React.SetStateAction<number>>;
  configurationsList: conigurations[] | null;
  getConfigurations: (force: boolean) => void;
  advisorsActive: boolean;
  MerchantIDOP: string;
  PublicAPIKeyDOP: string;
  DeviceSesionID: string;
  UrlComprobant: string;
  RecalcIndividualPrice: () => void;
  IndividualPrice: number;
  setCameraActive: React.Dispatch<React.SetStateAction<boolean>>;
  UsersList: any;
  getUsers: () => void;
  USD: any;
  exchangeRates: Ratesinterface;
  terminalsConfig: string[];
  dynamicUrlIntranet: string;
  tpvList: any[],
}
/**
 * Configuration record retrieved from the backend service.
 */
export interface conigurations {
  id: string;
  concept: string;
  configurationInfo: string;
  isFront: boolean;
}
/**
 * Structure holding currency exchange rates used across the application.
 */
interface Ratesinterface {
  USD: number | null;
  EUR: number | null;
  GBP: number | null;
  JPY: number | null;
  MXN: number | null;
}
const ConfigurationsContext = createContext<
  ConfigurationsContextType | undefined
>(undefined);

/**
 * Provides configuration values loaded from the backend to its children.
 *
 * @param children - Components that require configuration data.
 */
export const ConfigurationsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { user } = useAuth();
  const location = useLocation();
  const getStoredLanguageFlag = () => {
    if (typeof window === "undefined") return "";
    const raw = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (!raw) return "";
    return raw.toLowerCase();
  };
  const [txt, setTxt] = useState<DefaultText[]>(defaultxt);
  const [currentlenguage, setLenguage] = useState<number>(0);
  const [lenguageList, setLenguagesList] = useState<string[]>(defaultlenguages);
  const [flags, setFlags] = useState<string[]>(defaultflags);
  const [taxVisitax, setTaxVisitax] = useState<number | null>(null);
  const [umaValue, setUmaValue] = useState<number | null>(null);
  const [price, setPrice] = useState<{ mxn: number; usd: number }>({
    mxn: 0,
    usd: 0,
  });
  const [servicecharge, setServiceCharge] = useState<number | null>(null);
  const [visitorsLimit, setVisitorsLimit] = useState<number | null>(null);
  const [exchangeRates, setExchangeRates] = useState<Ratesinterface>({
    USD: null,
    EUR: null,
    GBP: null,
    JPY: null,
    MXN: 1,
  });
  const [configurationsList, setConfigurationsList] = useState<
    conigurations[] | null
  >(null);

  const [advisorsActive, setAdvisorsActice] = useState(true);
  const [MerchantIDOP, setMerchantIDOP] = useState("");
  const [PublicAPIKeyDOP, setPulicAPIKeyOP] = useState("");
  const [DeviceSesionID, setDeviceSesionID] = useState("");
  const [UrlComprobant, setUrlComprobant] = useState("");
  const [IndividualPrice, setIndividualPrice] = useState(1);
  const [cameraActive, setCameraActive] = useState(false);
  const [UsersList, setUsersList] = useState<any>(null);
  const [terminalsConfig, setTerminalsConfig] = useState([]);
  const [dynamicUrlIntranet, setDynamicUrlIntranet] = useState("");
  const [tpvList, setTpvList] = useState<any[]>([]);
  const [tpvListLoaded, setTpvListLoaded] = useState(false);
  const [USD, setUSD] = useState<any>(null);


  const { VisitaxGet } = useAxios();

  useEffect(() => {
    getConfigurations(false);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const selectedFlag = flags[currentlenguage];
    if (!selectedFlag) return;
    localStorage.setItem(LANGUAGE_STORAGE_KEY, selectedFlag.toLowerCase());
  }, [currentlenguage, flags]);

  useEffect(() => {
    if (user && !tpvListLoaded) getTPVList();
  }, [user, tpvListLoaded]);

  const getUsers = () => {
    const onUserResponse = (response: any) => {
      if (response.status === 200) {
        setUsersList(response.data.data);
        return;
      }
    };
    VisitaxGet(User, onUserResponse);
  };

  const getConfigurations = (force: boolean) => {
    const onResponse = (response: any) => {
      if (response.status === 200) {
        const configs = response.data.data;
        setConfigurationsList(configs);
        const uma = Number(
          configs.find((item: any) => item.concept === "UMA")?.configurationInfo
        );
        const taxvisitax = Number(
          configs.find((item: any) => item.concept === "TaxVisitax")
            ?.configurationInfo
        );
        const servicecharge = Number(
          configs.find((item: any) => item.concept === "ServiceCharge")
            ?.configurationInfo
        );
        const visitorslimit = Number(
          configs.find((item: any) => item.concept === "LimitOfVisitors")
            ?.configurationInfo
        );
        const publicApikey = configs.find(
          (item: any) => item.concept === "PUBLICAPIKEYOPENPAY"
        )?.configurationInfo;
        const merchantId = configs.find(
          (item: any) => item.concept === "OPENPAYID"
        )?.configurationInfo;
        const lenguaguagesList = JSON.parse(
          configs.find((item: any) => item.concept === "Languages")
            ?.configurationInfo
        );

        const UrlComprobant = configs.find(
          (item: any) => item.concept === "URLVoucherVisitax"
        )?.configurationInfo;

        const EUR = configs.find(
          (item: any) => item.concept === "EUR"
        )?.configurationInfo;

        const GBP = configs.find(
          (item: any) => item.concept === "GBP"
        )?.configurationInfo;

        const JPY = configs.find(
          (item: any) => item.concept === "JPY"
        )?.configurationInfo;

        const terminals = configs.find(
          (item: any) => item.concept === "Terminals"
        )?.configurationInfo;

        const dynamicUrl = configs.find(
          (item: any) => item.concept === "dynamicUrl"
        )?.configurationInfo;

        const lenguages = lenguaguagesList.languages;
        const flags = lenguaguagesList.flags;
        const txt = lenguaguagesList.txt;
        const storedFlag = getStoredLanguageFlag();
        const storedFlagIndex = flags.findIndex(
          (flag: string) => flag.toLowerCase() === storedFlag
        );

        setExchangeRates((prev) => ({
          ...prev,

          EUR: EUR,
          GBP: GBP,
          JPY: JPY,
        }));
        setUrlComprobant(UrlComprobant);
        setPulicAPIKeyOP(publicApikey);
        setMerchantIDOP(merchantId);
        setTxt(txt);
        setFlags(flags);
        setLenguagesList(lenguages);
        if (storedFlagIndex >= 0) {
          setLenguage((prev) => (prev === storedFlagIndex ? prev : storedFlagIndex));
        }
        setVisitorsLimit(visitorslimit);
        setTaxVisitax(taxvisitax);
        setUmaValue(uma);
        setServiceCharge(servicecharge);
        setTerminalsConfig(JSON.parse(terminals))
        setDynamicUrlIntranet(dynamicUrl)
        setAdvisorsActice(
          configs.find((item: any) => item.concept === "3dsAdvisorsActive")
            ?.configurationInfo
        );
        return;
      }
      setTimeout(() => {
        getConfigurations(false);
      }, 1000);
    };
    if (!configurationsList || force) {
      VisitaxGet(FrontConfigurations, onResponse);
    }
  };


  useEffect(() => {
    const isPaymentRoute = location.pathname.startsWith("/Payment");
    if (!isPaymentRoute || !MerchantIDOP || !PublicAPIKeyDOP) return;

    let cancelled = false;

    const init = async () => {
      try {
        await loadOpenPay();
        if (cancelled || !window.OpenPay) return;

        window.OpenPay.setId(MerchantIDOP);
        window.OpenPay.setApiKey(PublicAPIKeyDOP);
        window.OpenPay.setSandboxMode(!isProduction());

        // Espera a que exista el formulario (DynamicForm) con id="paymentForm".
        for (let i = 0; i < 15; i++) {
          if (cancelled) return;
          if (document.getElementById("paymentForm")) break;
          await new Promise((r) => setTimeout(r, 150));
        }

        if (cancelled) return;
        const deviceDataId = window.OpenPay.deviceData?.setup?.("paymentForm");
        if (deviceDataId) setDeviceSesionID(deviceDataId);
      } catch (error) {
        console.error("Error inicializando OpenPay:", error);
      }
    };

    init();
    return () => {
      cancelled = true;
    };
  }, [MerchantIDOP, PublicAPIKeyDOP, location.pathname]);

  useEffect(() => {
    const lockOrientation = async () => {
      if (window.screen?.orientation && typeof (window.screen.orientation as any).lock === "function") {
        try {
          if (!cameraActive) {
            // Bloquea la orientación a retrato
            await (window.screen.orientation as any).lock("portrait");
          } else if (window.screen.orientation.unlock) {
            // Desbloquea la orientación cuando la cámara está activa
            window.screen.orientation.unlock();
          }
        } catch (error) {
          // No soportado en muchos navegadores; evitamos ensuciar consola (Lighthouse Best Practices).
        }
      }
    };

    lockOrientation();
  }, [cameraActive]);

  // useEffect(() => {
  //   const fetchExchangeRates = async () => {
  //     const ACCESS_KEY = "8c923260d27e89d3544990031d80badf";
  //     try {
  //       const response = await axios.get(
  //         `https://api.currencylayer.com/live?access_key=${ACCESS_KEY}`
  //       );
  //       const rates = response.data.quotes;

  //       // Equivalencia de 1 MXN en USD
  //       const usdPerMxn = 1 / rates.USDMXN;

  //       // Equivalencias de 1 MXN en otras monedas
  //       const eurPerMxn = usdPerMxn * rates.USDEUR;
  //       const gbpPerMxn = usdPerMxn * rates.USDGBP;
  //       const jpyPerMxn = usdPerMxn * rates.USDJPY;

  //       setExchangeRates({
  //         USD: Number(usdPerMxn.toFixed(5)),
  //         EUR: Number(eurPerMxn.toFixed(5)),
  //         GBP: Number(gbpPerMxn.toFixed(5)),
  //         JPY: Number(jpyPerMxn.toFixed(5)),
  //         MXN: 1,
  //       });
  //     } catch (error) {
  //       console.error("Error al obtener las tasas de cambio:", error);
  //     }
  //   };

  //   fetchExchangeRates();
  // }, []);

  useEffect(() => {
    if (!umaValue || price.mxn === 0 || price.usd !== 0) return;

    let cancelled = false;

    const run = () => {
      fetch("https://mx.dolarapi.com/v1/cotizaciones/usd")
        .then((response) => response.json())
        .then((data) => {
          if (cancelled) return;
          if (!price.mxn) return;

          const usdValue = Number(price.mxn) / data.venta;
          setUSD(usdValue);
          setExchangeRates((prev) => ({
            ...prev,
            USD: 1 / data.venta,
          }));

          setPrice((prev) => ({
            ...prev,
            usd: Number(usdValue.toFixed(2)),
          }));
        })
        .catch(() => {
          // No bloqueamos el render ni ensuciamos consola si el servicio falla.
        });
    };

    const schedule = () => {
      setTimeout(run, 2500);
    };

    if (document.readyState === "complete") {
      schedule();
    } else {
      window.addEventListener("load", schedule, { once: true });
    }

    return () => {
      cancelled = true;
    };
  }, [umaValue, price.mxn, price.usd]);

  //https://api.currencylayer.com/list?access_key=8c923260d27e89d3544990031d80badf

  useEffect(() => {
    if (umaValue && taxVisitax && servicecharge) {
      const individualPrice = CalcIndividualPrice(1);
      if (individualPrice < 100 && isProduction()) {
        RecalcIndividualPrice();
        return;
      }
      setIndividualPrice(individualPrice);

      setPrice((prev) => ({
        ...prev,
        mxn: CalcIndividualPrice(1),
      }));
    }
  }, [taxVisitax, umaValue, servicecharge]);

  const CalcIndividualPrice = (NumberofVisitors: number) => {
    let cost = taxVisitax === null ? 1 : taxVisitax;
    let precioUMA = umaValue === null ? 1 : umaValue;

    let importe = Math.round(
      cost * precioUMA * NumberofVisitors +
      (servicecharge ? servicecharge : 0) * NumberofVisitors
    );

    const importe_ind = Math.ceil(importe / NumberofVisitors);
    return importe_ind;
  };

  const getTPVList = () => {
    const onDevicesResponse = (response: any) => {
      if (response.status === 200) {
        const devices = response?.data?.data;
        if (Array.isArray(devices) && devices.length === 0) {
          setTpvList([]);
          setTpvListLoaded(true);
          return;
        }

        const devicesList = devices
          ?.filter((device: any) => device?.type == "TPV")
          .map((device: any) => ({
            id: device?.serialNumber,
            label: device?.device_key,
          }));
        setTpvList(devicesList ?? []);
        setTpvListLoaded(true);
        return;
      }
      setTpvList(["Ninguna TPV"])
      setTimeout(() => {
        setTpvList([])
      }, 1000)
      setTpvListLoaded(true);
    };
    VisitaxGet(Devices, onDevicesResponse);
  }

  const RecalcIndividualPrice = () => {
    setConfigurationsList(null);
    getConfigurations(true);
  };

  return (
    <ConfigurationsContext.Provider
      value={{
        txt,
        lenguageList,
        flags,
        currentlenguage,
        price,
        umaValue,
        taxVisitax,
        servicecharge,
        visitorsLimit,
        configurationsList,
        advisorsActive,
        PublicAPIKeyDOP,
        MerchantIDOP,
        DeviceSesionID,
        UrlComprobant,
        IndividualPrice,
        UsersList,
        USD,
        exchangeRates,
        terminalsConfig,
        dynamicUrlIntranet,
        tpvList,
        getUsers,
        CalcIndividualPrice,
        RecalcIndividualPrice,
        setLenguage,
        getConfigurations,
        setCameraActive,

      }}
    >
      {children}
    </ConfigurationsContext.Provider>
  );
};

/**
 * Access the configuration context values.
 *
 * @throws Error if used outside of {@link ConfigurationsProvider}.
 */
export const useConfigurations = () => {
  const context = React.useContext(ConfigurationsContext);
  if (context === undefined) {
    throw new Error(
      "ConfigurationsProvider must be used within an AuthProvider"
    );
  }
  return context;
};
